/* eslint-disable */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const MockExampleMonitor = ({ specSelectors, getSystem }) => {
  const [currentExample, setCurrentExample] = useState(null);
  const [currentEndpoint, setCurrentEndpoint] = useState(null);
  const [debugInfo, setDebugInfo] = useState('');

  const scanForEndpoint = () => {
    console.log('Scanning for endpoint...');
    
    // Find the active operation - try multiple selectors
    let activeOperation = document.querySelector('.opblock.is-open');
    if (!activeOperation) {
      activeOperation = document.querySelector('.opblock.opblock-post.is-open') || 
                        document.querySelector('.opblock.opblock-get.is-open') || 
                        document.querySelector('.opblock.opblock-put.is-open') ||
                        document.querySelector('.opblock.opblock-delete.is-open');
    }
    
    if (!activeOperation) {
      console.log('No active operation found');
      setDebugInfo('No active operation found');
      return;
    }

    console.log('Found active operation:', activeOperation);

    // Extract method and path - try multiple selectors
    let method = null;
    let path = null;
    
    // Method extraction
    const methodElement = activeOperation.querySelector('.opblock-summary-method');
    if (methodElement) {
      method = methodElement.textContent.trim().toUpperCase();
    } else {
      // Try to get from class name
      const classList = activeOperation.className;
      if (classList.includes('opblock-post')) method = 'POST';
      else if (classList.includes('opblock-get')) method = 'GET';
      else if (classList.includes('opblock-put')) method = 'PUT';
      else if (classList.includes('opblock-delete')) method = 'DELETE';
      else if (classList.includes('opblock-patch')) method = 'PATCH';
    }
    
    // Path extraction - try multiple approaches
    const pathElement = activeOperation.querySelector('.opblock-summary-path [data-path]') ||
                       activeOperation.querySelector('.opblock-summary-path a') ||
                       activeOperation.querySelector('.opblock-summary-path');
    
    if (pathElement) {
      path = pathElement.getAttribute('data-path') || 
             pathElement.textContent.trim() ||
             pathElement.innerText.trim();
    }
    
    console.log('Method:', method, 'Path:', path);
    
    if (method && path) {
      // Find the example dropdown or example content
      const responseSection = activeOperation.querySelector('.responses-wrapper');
      
      // Try to find example selector
      const exampleDropdown = activeOperation.querySelector('.examples-select select') ||
                              activeOperation.querySelector('select.examples-select');
      const selectedExample = exampleDropdown ? exampleDropdown.value : 'default';
      
      // Find the example content - try multiple selectors
      const exampleCode = activeOperation.querySelector('.microlight') ||
                         activeOperation.querySelector('.highlight-code') ||
                         activeOperation.querySelector('.example-value') ||
                         activeOperation.querySelector('pre.example') ||
                         activeOperation.querySelector('.response-col_description pre') ||
                         activeOperation.querySelector('.model-example');
                         
      const exampleContent = exampleCode ? exampleCode.textContent.trim() : null;
      
      console.log('Example dropdown:', exampleDropdown);
      console.log('Selected example:', selectedExample);
      console.log('Example code element:', exampleCode);
      console.log('Example content:', exampleContent);
      
      setCurrentEndpoint({ method, path });
      setCurrentExample({ name: selectedExample, content: exampleContent });
      setDebugInfo(`Found: ${method} ${path}`);
    } else {
      setDebugInfo(`Missing: method=${method}, path=${path}`);
    }
  };

  useEffect(() => {
    // Initial scan
    setTimeout(scanForEndpoint, 1000);

    // Monitor DOM changes
    const observer = new MutationObserver(() => {
      scanForEndpoint();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'aria-expanded']
    });

    // Also monitor clicks
    document.addEventListener('click', () => {
      setTimeout(scanForEndpoint, 500);
    });

    return () => observer.disconnect();
  }, []);

  const handleUseMock = () => {
    if (!currentEndpoint || !currentExample) {
      alert('Please expand an endpoint and select an example first.');
      return;
    }

    let exampleData = currentExample.content;
    if (exampleData) {
      try {
        exampleData = JSON.parse(exampleData);
      } catch (e) {
        // Not JSON, use as is
      }
    }

    const mockConfig = {
      method: currentEndpoint.method,
      path: currentEndpoint.path,
      exampleName: currentExample.name,
      exampleData: exampleData
    };

    console.log('Mock Configuration:', mockConfig);
    
    alert(`Mock Configuration:
Method: ${mockConfig.method}
Path: ${mockConfig.path}
Example: ${mockConfig.exampleName || 'default'}
Data: ${typeof mockConfig.exampleData === 'object' ? JSON.stringify(mockConfig.exampleData, null, 2) : mockConfig.exampleData}`);

    // Store in window for later use
    window.__lastMockConfig = mockConfig;
  };

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      zIndex: 1000,
      backgroundColor: 'white',
      padding: '10px',
      borderRadius: '8px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.2)'
    }}>
      <button
        type="button"
        onClick={handleUseMock}
        style={{
          backgroundColor: '#4CAF50',
          color: 'white',
          padding: '10px 20px',
          fontSize: '14px',
          fontWeight: 'bold',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        🎯 Use Current Example for Mock
      </button>
      {currentEndpoint && (
        <div style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
          Monitoring: {currentEndpoint.method} {currentEndpoint.path}
        </div>
      )}
      {debugInfo && (
        <div style={{ marginTop: '5px', fontSize: '11px', color: '#999' }}>
          Debug: {debugInfo}
        </div>
      )}
      <button
        type="button"
        onClick={scanForEndpoint}
        style={{
          marginTop: '5px',
          backgroundColor: '#2196F3',
          color: 'white',
          padding: '5px 10px',
          fontSize: '12px',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          width: '100%'
        }}
      >
        🔄 Rescan
      </button>
    </div>
  );
};

MockExampleMonitor.propTypes = {
  specSelectors: PropTypes.object,
  getSystem: PropTypes.func,
};

MockExampleMonitor.defaultProps = {
  specSelectors: null,
  getSystem: null,
};

export default MockExampleMonitor;